// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"4b32a06d","673":"4b32a06d"}[chunkId] + ".chunk.css";
};